import {BaseManager} from "../../infrastructure/managers/base-manager";
import {BaseDomainRequest} from "../../infrastructure/models/base-domain-request";
import {BaseDomainParams} from "../../infrastructure/models/params/base-domain-params";
import {BaseUtilsService} from "../../infrastructure/domain-services/base-utils-service";

export class DomainRequestManager extends BaseManager {
  requests: Array<BaseDomainRequest> = [];

  static injectables = [...BaseUtilsService.injectables];

  create(params: BaseDomainParams, promise: Promise): BaseDomainRequest {
    const request: BaseDomainRequest = new BaseDomainRequest(params, promise);
    this.requests.push(request);

    return request;
  }

  update(params: BaseDomainParams, promise): BaseDomainParams {
    const request: BaseDomainRequest = this.find(params);

    if (!request) {
      return null;
    }

    request.params = params;
    request.promise = promise;

    return request;
  }

  find(params: BaseDomainParams): BaseDomainRequest {
    const existingRequest: BaseDomainRequest = this.requests.find((request: BaseDomainRequest) => request.params.requestParams.equals(params.requestParams));

    return existingRequest;
  }

  register(params: BaseDomainParams): BaseDomainParams {
    let request: BaseDomainRequest = this.find(params);
    if (!request) {
      request = this.create(params);
    }
    request.callbacks[params.deltaCallbackId] = params.deltaCallback;

    return request;
  }

  unregister(callbackId: String) {
    this.requests = this.requests.filter((request: BaseDomainRequest) => !this.hasDeltaCallbacks(request, callbackId))
  }

  hasDeltaCallbacks(request: BaseDomainRequest, callbackId: String) {
    const callbackIds: Array<String> = Object.keys(request.callbacks).filter((id: String) => id.includes(callbackId));
    callbackIds.forEach((id: String) => delete request.callbacks[id]);

    const hasDeltaCallbacks = request.callbacks && (Object.keys(request.callbacks).length > 0);

    if (!hasDeltaCallbacks) {
      clearTimeout(request.timeoutId);
      request.promise = null;
    }

    return !hasDeltaCallbacks;
  }
}
